import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { GlobalService } from '../../services/global.service';
import { Globals } from '../globals.model';
import { MLService } from 'src/app/services/ml-service';

@Component({
  selector: 'app-model-delete',
  templateUrl: './model-delete.component.html',
  styleUrls: ['./model-delete.component.css']
})
export class ModelDeleteComponent {

  counter = 0;
  modelNotDeleted = false;
  notDeletedModel = [];
  isModelSerDelete = true;
  modelErrDelMsg = '';
  isDelErrorAPI = true;
  delErrModMessage = 'Message';
  selectedTextForDelete = '';
  isErrInDelCon = true;
  conDelErrMsg = '';

  constructor(
    public dialogRef: MatDialogRef<ModelDeleteComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly httpClient: HttpClient,
    public globalsConfig: Globals,
    private readonly globals: GlobalService,
    public mlService: MLService,) { }

  onDeleteClick(): void {
    for (const element of this.data.selectedData.selected) {
      this.deleteEachModel(element.id, this.data.selectedData.selected.length);
    }
  }

  deleteEachModel(modelId, selectedRowNumber) {
    const httpOptions = this.globals.gethttpHeader(this.data.accessToken);
    this.mlService.deleteEachModelData(modelId, httpOptions).subscribe((data: any): void => {
      this.counter++;
      if (this.counter === selectedRowNumber) {
        this.dialogRef.close('deleted');
      }
    }, (error: Error) => {
      this.notDeletedModel.push(modelId);
      this.modelNotDeleted = true;
      console.log('Model ' + modelId + ' not deleted because ' + error.message);
    });
  }

  onOkayClick(): void {
    if (this.counter > 0) {
      this.dialogRef.close('deleted');
    } else { this.dialogRef.close(); }
  }

  onCancelClick(): void {
    this.dialogRef.close();
  }

  erroHandlingDeleteSer(msg, error) {
    this.isModelSerDelete = true;
    if (msg === 'service') {
      this.modelErrDelMsg = msg + error;
    } else {
      this.modelErrDelMsg = msg;
    }
  }

  erroHandlingDeleteAPI(msg, error) {
    if (msg === 'inApi') {
      this.isDelErrorAPI = true;
    } else {
      this.isDelErrorAPI = false;
    }
    this.delErrModMessage = msg + error;
  }

  selectTextForDelete(newValue) {
    if (newValue === 'Added') {
      this.selectedTextForDelete = 'Added ' + newValue;
    } else {
      this.selectedTextForDelete = newValue;
    }
  }

  erroInConnInDelete(error) {
    if (error === 'inConnection') {
      this.isErrInDelCon = false;
      this.conDelErrMsg = 'Error is: ' + error;
    } else {
      this.conDelErrMsg = 'Error is in connection: ' + error;
    }
  }

}
